import { createContext, useContext } from "react";

export interface ProviderSearchCriteria {
    searchText: string;
    status?: string;
    currentPage: number;
}

export interface ProviderSearchContextParams {
    initialCriteria: ProviderSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<ProviderSearchCriteria>>;
}

const defaultProviderSearchCriteria: ProviderSearchCriteria = {
    searchText: "",
    status: undefined,
    currentPage: 1,
};

const ProviderSearchContext = createContext<ProviderSearchContextParams>({
    initialCriteria: defaultProviderSearchCriteria,
    setCriteria: () => {},
});

const useProviderSearch = () => {
    return useContext(ProviderSearchContext);
};

export { ProviderSearchContext, useProviderSearch, defaultProviderSearchCriteria };
